<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { BubbleButtonProps } from '../types'
import { cn } from '@/lib/utils'
import chatIcon from '@/assets/netwatch-chat-icon-duotone.svg'
import { getSvgCSS } from '@/utils'

const props = defineProps<BubbleButtonProps>()

const chatIconCss = ref<string>()
const defaultButtonColor = '#0072A3'

onMounted(async () => {
  chatIconCss.value = await getSvgCSS(chatIcon)
})
</script>

<template>
  <button
    part="button"
    :class="cn(
      'fixed bottom-5 shadow-md  rounded-full hover:scale-110 active:scale-95 transition-transform duration-200 flex justify-center items-center animate-fade-in mt-[20px]',
      props.size === 'large' ? ' w-16 h-16' : ' w-12 h-12',
      props.placement === 'left' ? ' left-5' : ' right-5',
    )"
    :style="`
      background-color: ${props.backgroundColor ?? defaultButtonColor};
      z-index: 2147483000;
    `"
    aria-label="Open netwatch"
    @click="props.toggleBot"
  >
    <div
      text-white :class="cn(
        'duration-200 transition',
        props.isBotOpened ? 'i-solar-double-alt-arrow-up-line-duotone' : '',
        props.placement === 'left'
          ? props.isBotOpened
            ? 'rotate-180'
            : 'rotate-0' : props.isBotOpened
            ? '-rotate-180'
            : 'rotate-0',
        props.size === 'large' ? 'text-3xl' : 'text-2xl',
      )"
      :style="`${props.iconColor ? `color: ${props.iconColor};` : 'color:  #FFF;'} ${props.isBotOpened ? '' : chatIconCss}`"
    />
  </button>
</template>
